import styled from "styled-components";

import { COLORS } from "@treelab/panda";

export const Container = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  user-select: none;
`;

export const NumberContainer = styled.div<{ isExpand: boolean }>`
  position: absolute;
  top: ${({ isExpand }) => (isExpand ? "96px" : "12px")};
  right: ${({ isExpand }) => (isExpand ? "48px" : "32px")};
  bottom: ${({ isExpand }) => (isExpand ? "96px" : "36px")};
  left: ${({ isExpand }) => (isExpand ? "48px" : "32px")};
  font-weight: bold;
  color: ${COLORS.greyDark1};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "Oswald", "SF Pro text", "PingFang SC", "Microsoft Yahei", "Roboto", sans-serif;
`;

export const UndefinedContainer = styled.div`
  font-size: 100px;
  line-height: 144px;
  color: ${COLORS.greyLight1};
  font-weight: bold;
  font-style: normal;
`;
